export const urlMappings = new Map([
  ["INST", "/installations"],
  ["SC_MANUAL_VALIDATION", "/ticket"],
  ["SC_DAILY", "/daily"],
  ["T_HPAY", "/transactions"],
  ["T_SPOTCHECK", "/live"],
  ["SC_ATR_STATUS", "/kiosk"],
  ["SC_PLAY_SESSIONS", "/sessions"],
  ["COLL", "/collection"],
  ["COLL_METERS", "/collection"],
  ["INTERIM", ""],
  ["COMPLIANCE", "/compliance"],
  ["OBS", "/compliance/observations"],
  ["AGE", "/compliance/age-verification"],
  ["ALERTS", "/compliance/alerts"],
  ["CUSTOMERS", "/compliance/customers"],
  ["INTERACTION", "/compliance/customer-interaction"],
  ["CUSTOMER", "/compliance/customer-incidents"],
  ["UNRESOLVED", "/compliance/unresolved-dispute"],
  ["SUSPICIOUS", "/compliance/suspicious-activity"],
  ["ENFORCE", "/compliance/enforcement"],
  ["SELF_EXCL", "/compliance/self-exclusion"],
  ["HISTORY", "/compliance/history"],
  ["AGC_CHECK", "/agc-check"],
]);
